import { FC } from "react";
import { IconProps } from "./types";

export const Home: FC<IconProps> = ({
  fill = "currentColor",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 9.12V20h5.6v-6.144h4.8V20H20V9.12L12 4 4 9.12z"
      fill={fill}
    />
  </svg>
);
